// =============================================================================
// Badge de Aprobaciones en el sidebar (mig. 058, oct-2026).
//
// Cuenta lo que ESTE usuario puede resolver (admin de sede, superadmin, dev).
// Al cajero no se le prende: no tiene nada que hacer, solo esperar.
// Se refresca por SSE cuando cambia cualquier solicitud y, por las dudas, cada
// 2 minutos (un SSE caído no debe dejar el badge congelado en 0).
// =============================================================================
import { useCallback, useEffect, useState } from 'react';
import { contadorAprobaciones } from '../../api/aprobaciones';
import { useRealtime } from './use-realtime';

export function useAprobacionesBadge(habilitado: boolean): number {
  const [n, setN] = useState(0);

  const cargar = useCallback(() => {
    if (!habilitado) { setN(0); return; }
    contadorAprobaciones()
      .then(r => setN(r.accionables || 0))
      .catch(() => { /* el badge no es crítico; se reintenta en el próximo evento */ });
  }, [habilitado]);

  useEffect(() => {
    cargar();
    if (!habilitado) return;
    const t = setInterval(cargar, 120_000);
    return () => clearInterval(t);
  }, [cargar, habilitado]);

  useRealtime(['aprobacion_actualizada'], () => cargar());
  return n;
}
